export default __webpack_public_path__ + "static/media/third.48df3d21.png";